export var shareToClipBoard = function (url) {
    navigator.clipboard.writeText(url);
};
